import React from "react";
import { Field, reduxForm } from "redux-form";
import { Toggle } from "Components/Form";
import NavButtons from "../Components/NavButtons";
import {
  isAgencyAdmin,
  isAgencyUser,
  isRolePlatformAdmin,
  token,
} from "../../../../modules/auth";
import { connect } from "react-redux";
import { Input } from "../../../../ui";
let SetReportOptions = props => {
  return (
    <div className={`bg-white ${props.className}`}>
      <h2 className="flex justify-between mb-6">
        <span>Report Options</span>
      </h2>
      <form onSubmit={props.handleSubmit}>
        <Field
          name="author_visible"
          label="Show author name"
          component={Toggle}
        />
        <Field
          name="author_image_visible"
          label="Include your profile picture"
          component={Toggle}
        />
        {!props.isAgencyUser && !props.isAgencyAdmin && !props.isEdgeAdmin ? (
          <Field
            name="share_internally"
            label="Share with your Company and Agency only"
            component={Toggle}
          />
        ) : (
          <Field component={Input} name="share_internally" type="hidden" />
        )}

        <NavButtons {...props} />
      </form>
    </div>
  );
};

SetReportOptions = reduxForm({
  form: "CreateSiteVisitForm",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(SetReportOptions);

export default connect(state => ({
  isAgencyUser: isAgencyUser(state),
  isAgencyAdmin: isAgencyAdmin(state),
  isEdgeAdmin: isRolePlatformAdmin(state),
}))(SetReportOptions);
